import {
  TokenBalanceText,
  useTokenBalanceValue,
} from '@/components/TransactionModule/TMTokenBalance';

import type { ChainAddress } from '@/utils/models';

type TokenBalanceLineProps = {
  accountAddress: ChainAddress | undefined;
  chainId: number | undefined;
  tokenAddress: ChainAddress | undefined;
};

/** Renders the connected account's token balance without writing trade state. */
export function TokenBalanceLine(props: TokenBalanceLineProps) {
  return <TokenBalanceText balance={useTokenBalanceValue(props)} chainId={props.chainId} />;
}
